import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Row, Col, Checkbox, Card, Switch } from "antd";
import { API_CREATE_USER } from "api/user-mangement";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { API_UPLOAD_IMAGE } from "api/user-mangement";
import { CONSTANTS } from "config/constant";
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import axios from "axios";
import TextareaField from "components/AddressAutocomplete/TextareaField";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { API_LIST_USER } from "api/user-mangement";
import { API_UPDATE_USER } from "api/user-mangement";
import { UseUser } from "config/selectedUserContext";
import { RxCrossCircled } from "react-icons/rx";

const CreateOrderUser = ({ onSuccessModal, ref }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState();
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 });
  const [searchName, setSearchName] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState();
  const [suggestions, setSuggestions] = useState([]);
  const { selectUser, selectedUser } = UseUser();
  const [isEditing, setIsEditing] = useState(0);
  const [selectedCustmerType, setSelectedCustmerType] = useState("home");
  const [userData, setUserData] = useState("");
  const [isCheckedUser, setIsheCkedUser] = useState(false);
  const [addressOne, setAddressOne] = useState(false);

  const Navigate = useNavigate();
  const [locationError, setLocationErrorr] = useState("");
  const [fileList, setFileList] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const { t } = useTranslation();
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChangess = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  const handleInputChange = (event, setFieldValue) => {
    const value = event.target.value;
    setSearchName(value);
    if (value === "") {
      setFieldValue("first_name", "");
      setFieldValue("last_name", "");
      setFieldValue("email", "");
      setFieldValue("phone_no", "");
      setFieldValue("location", "");
      setFieldValue("unhashed_password", "");
      setFieldValue("address.building", "");
      setFieldValue("address.apartment", "");
      setFieldValue("address.floor", "");
      setFieldValue("address.street", "");
      setFieldValue("address.city", "");
      setFieldValue("address.province", "");
      setFieldValue("address.country", "");
      setFieldValue("address.additional_directions", "");
      setUserData([]);
    }
  };
  const handleSuggestionClick = (user, setFieldValue) => {
    // Update state with selected user's data
    console.log(user, "seggestedUser");
    setUserData(user);
    setSelectedAddress(user?.address);
    console.log("Selected user:", user);
    setFieldValue("first_name", user?.first_name);
    setFieldValue("last_name", user?.last_name);
    setFieldValue("email", user?.email);
    setFieldValue("phone_no", user?.phone_no);
    setFieldValue("location", user?.address[0]?.location);
    setFieldValue("unhashed_password", user?.unhashed_password);
    setFieldValue("address", user?.address);
    // setFieldValue("address.building", user?.address[0]?.building);
    // setFieldValue("address.apartment", user?.address[0]?.apartment);
    // setFieldValue("address.floor", user?.address[0]?.floor);
    // setFieldValue("address.street", user?.address[0]?.street);
    // setFieldValue("address.city", user?.address[0]?.city);
    // setFieldValue("address.province", user?.address[0]?.province);
    // setFieldValue("address.country", user?.address[0]?.country);
    // setFieldValue(
    //   "address.additional_directions",
    //   user?.address[0]?.additional_directions
    // );
    setFileList([
      {
        uid: "-1",
        name: "image.png",
        status: "done",
        url: CONSTANTS?.BACKEND_URL + user?.profile_image?.[0]?.file_url,
      },
    ]);
    setImage(user?.profile_image);
    setCurrentData(user);
    // setSearchName(""); // Clear the input field
    setSuggestions([]); // Clear suggestions
  };
  useEffect(() => {}, []);

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // Create a FormData object
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_IMAGE(formData);

      console.log("result", response, file);
      // Handle success
      const newFileList = [
        {
          uid: response.id, // Replace with the unique ID you receive from the server
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.BACKEND_URL + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
        },
      ];

      setFileList(newFileList);
      setImage(response?.file);
      onSuccess();
      toast.success(response?.message);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };

  const updateSelection = (indexToUpdate) => {
    setSelectedAddress((prevData) => {
      selectedAddress?.map((item, index) =>
        index === indexToUpdate ? { ...item, is_selected: true } : item
      );
    });
    // setUserData((prevData) =>
    //   prevData?.address?.map((item, index) =>
    //     index === indexToUpdate ? { ...item, is_selected: false } : item
    //   )
    // );
  };
  const handleCheckBox = (isChecked, element, setFieldValue, values, idx) => {
    if (isChecked === true) {
      setFieldValue(
        "address",
        values?.address?.map((address, i) =>
          i === idx ? { ...address, is_selected: false } : address
        )
      );
      setIsheCkedUser(true);
    } else {
      setFieldValue(
        "address",
        values?.address?.map((address, i) =>
          i === idx
            ? { ...address, is_selected: true }
            : { ...address, is_selected: false }
        )
      );
      setIsheCkedUser(false);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Image
      </div>
    </button>
  );

  const searchAddress = async (address, idx) => {
    try {
      const response = await axios.get(
        // `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${CONSTANTS?.googleApikey}`
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/places-autocomplete?query=${address}`
      );

      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;

        setAutocompleteSuggestions({ [idx]: predictions });
      } else {
        setAutocompleteSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching data from Google Places API", error);
    }
  };

  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    try {
      // Fetch place details using the Place Details request
      const response = await axios.get(
        // `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedAddress.place_id}&key=${CONSTANTS?.googleApikey}`
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/place-details?place_id=${selectedAddress.place_id}`
      );

      if (response.data.status === "OK") {
        const placeDetails = response.data.result;

        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;

        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;
        placeDetails.address_components.forEach((component) => {
          console.log(`${component.types[0]}: ${component.long_name}`);
        });

        const streetAddress = placeDetails?.address_components?.find(
          (component) => component.types.includes("route")
        )?.long_name;

        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;

        // setFieldValue("location", placeDetails?.formatted_address);
        setFieldValue(
          `address.${isEditing}.location`,
          selectedAddress?.description
        );
        setFieldValue(`address.${isEditing}.city`, city);
        setFieldValue(`address.${isEditing}.province`, state);
        setFieldValue(`address.${isEditing}.country`, country);
        setFieldValue(`address.${isEditing}.street`, streetAddress);
        setFieldValue(`address.${isEditing}.location_lat`, lat);
        setFieldValue(`address.${isEditing}.location_lng`, lng);
        setFieldValue(`address.${isEditing}.coordinates`, [lat, lng]);
        setFieldValue(`address.${isEditing}.geo`, { coordinates: [lat, lng] });
        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);
        setFieldValue("geo", { coordinates: [lat, lng] });
        setAutocompleteSuggestions([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }

      // Clear the autocomplete suggestions
      setAutocompleteSuggestions([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
        phone: searchPhone,
      };
      const newData = await API_LIST_USER(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData?.totalUsers }); // Assuming API response contains total count
      setSuggestions(newData.users); // Assuming newData contains an array of users
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  const handleCheckboxChange = (option) => {
    if (selectedCustmerType === option) {
      setSelectedCustmerType(null); // Uncheck if already selected
    } else {
      setSelectedCustmerType(option); // Check the selected option
    }
  };

  const hasNonEmptyLocation = (address) => {
    return address.location && address.location.trim() !== "";
  };

  function flattenLocations(locations) {
    return locations.map(({ address, ...rest }) => ({
      ...rest,
      ...address,
    }));
  }

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    // setCurrentData({ ...currentData, ...values }); // Merge currentData with new values
    const updatedData = { ...currentData, ...values }; // Merge currentData with new values
console.log("updatedData", updatedData);
    // const isAddressSelected = updatedData?.address?.some(
    //   (address) => address.is_selected
    // );
    if (updatedData?.address?.length === 1) {
      updatedData.address[0].is_selected = true;
    }
    
    const isAddressSelected = updatedData?.address?.some(
      (address) => address.is_selected
    );
    
  
    if (!isAddressSelected) {
      toast.error("Please select at least one address.");
      setSubmitting(false);
      return; // Prevent the submission if no address is selected
    }
    if (currentData) {
      console.log("currentData ==>", updatedData);

      selectUser(currentData);

      const {
        location,
        address,
        location_lat,
        location_lng,
        password,
        ...userData
      } = updatedData;
      const addressss = address?.filter(hasNonEmptyLocation);
      const payload = {
        ...userData,
        profile_image: image,
        address: addressss,
        location: addressss[0]?.location,
        address_type: selectedCustmerType,
        geo: {
          coordinates: [location_lat, location_lng],
        },
      };
      try {
        let users = await API_UPDATE_USER(payload, currentData?._id);
        // selectUser(users?.user);
        const res = users?.user;
        const { address: addresssse } = res;
        const selectedIndex = addresssse.findIndex(
          (address) => address.is_selected
        );
        if (selectedIndex > -1) {
          const [selectedAddress] = addresssse?.splice(selectedIndex, 1);
          addresssse?.unshift(selectedAddress);
        }
        const web = { ...res, address: addresssse };
        if (web) {
          selectUser(web);
        }

        toast.success(users?.message);
        onSuccessModal();
      } catch (error) {
        console.log("error update", error);
        toast.error(error?.response?.data?.message);
      }
    } else {
      try {
        const { location, address, location_lat, location_lng, ...storeData } =
          values;
        const addressss = address?.filter(hasNonEmptyLocation);
        const payload = {
          ...storeData,
          profile_image: image,
          address: addressss,
          location: addressss[0]?.location,
          address_type: selectedCustmerType,
          geo: {
            coordinates: [location_lat, location_lng],
          },
        };
        const userData = await API_CREATE_USER(payload);
        selectUser(userData?.user);
        setCurrentData(userData?.user);
        const res = userData?.user;
        const { address: addresssse } = res;
        const selectedIndex = addresssse?.findIndex(
          (address) => address.is_selected
        );
        if (selectedIndex > -1) {
          const [selectedAddress] = addresssse?.splice(selectedIndex, 1);
          addresssse.unshift(selectedAddress);
        }
        const web = { ...res, address: addresssse };
        if (web) {
          selectUser(web);
        }
        toast.success(userData?.message);
        onSuccessModal();
      } catch (error) {
        toast.error(error?.response?.data?.errors?.email);

        console.error("error", error);
        // toast.error(error?.response?.data?.message);
      } finally {
        setSubmitting(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName, searchPhone]);

  const handleSelectAddress = (element, setFieldValue, idx) => {
    setFieldValue("address", element);
    // setIsEditing(idx);
  };
  useEffect(() => {
    if (searchName === "") {
      setUserData([]);
    }
  }, [searchName]);
  const handleSaveAddress = (setFieldValue, values, location) => {
    console.log(location, "locationfasdf");
    const filteredAddresses = values?.address?.filter(hasNonEmptyLocation);
    setFieldValue(
      "address",
      filteredAddresses?.map((address, i) =>
        address?.location === location
          ? { ...address, is_selected: true }
          : { ...address, is_selected: false }
      )
    );
    // setFieldValue("address", filteredAddresses);
    setUserData(values);

    setIsEditing(null);
  };

  //  useEffect(() => {
  //   handleResetOrderUserForm(resetForm);
  // }, [handleResetOrderUserForm]);
  const formikRef = useRef(null);
  useImperativeHandle(ref, () => ({
    resetForm: () => {
      if (formikRef.current) {
        formikRef.current.resetForm();
      }
    },
  }));
  useEffect(() => {
    if (userData?.address?.length > 0) {
      setIsEditing(null);
    }
  }, [userData?.address?.length]);
  const divRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (userData?.address?.length === 1) {
      setAddressOne(true);
    } else {
      setAddressOne(false);
    }
  }, [userData]); // This will run only when userData or setFieldValue changes

  console.log("isCheckedUser", isCheckedUser);
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className=" w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            innerRef={formikRef}
            enableReinitialize
            initialValues={{
              first_name: "",
              last_name: "",
              location: "",
              location_lat: "",
              location_lng: "",
              password: "",
              geo: { coordinates: [] },
              email: "",
              phone_no: "",
              address: [
                {
                  location: "",
                  is_selected: false,
                  building: "",
                  apartment: "",
                  coordinates: [],
                  floor: "",
                  geo: { coordinates: [] },
                  street: "",
                  city: "",
                  province: "",
                  country: "",
                  additional_directions: "",
                },
              ],
            }}
            validationSchema={Yup.object({
              first_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              last_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              // password: Yup.string().required("Required"),
              phone_no: Yup.string().required("Required"),
              // .matches(/^[0-9]+$/, "Phone number must contain only numbers"),
              // location: Yup.string().required("Required"),
              address: Yup.array().of(
                Yup.object({ location: Yup.string().required("Required") })
              ),
            })}
            onSubmit={handleSubmit}
          >
            {({
              isSubmitting,
              setFieldValue,
              values,
              errors,
              push,
              resetForm,
            }) => (
              <Form className="flex w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div className="mb-3 flex justify-center">
                  <Upload
                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                    listType="picture-circle"
                    customRequest={customRequest}
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChangess}
                  >
                    {fileList.length == 1 ? null : uploadButton}
                  </Upload>
                  {previewImage && (
                    <Image
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </div>
                <h1
                  style={{
                    fontWeight: "500",
                    fontSize: "20px",
                    textAlign: "start",
                    marginBottom: "2rem",
                  }}
                >
                  {t("User Details")}
                </h1>

                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Phone No")}
                      </label>
                      <div className="relative">
                        <PhoneInput
                          country={"sa"}
                          // disableDropdown={true}
                          // onlyCountries={["sa"]}
                          countryCodeEditable={false}
                          autoFormat={true}
                          // enableLongNumbers={false}
                          className="w-100 mt-2"
                          inputProps={{
                            name: "phone_no",
                            className:
                              "bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500 pl-[3rem]",
                            placeholder: "Phone No",
                          }}
                          value={values?.phone_no}
                          onChange={(value) => {
                            setFieldValue("phone_no", value);
                            setSearchPhone(value);
                            // handleInputChange(e, setFieldValue);
                          }}
                        />
                        <div
                          className="absolute -top-5 right-0"
                          onClick={() => {
                            resetForm();
                            setUserData(null);
                            setIsEditing(0);
                            setFileList([]);
                            setImage("");
                            setFieldValue("phone_no", "+966");
                          }}
                        >
                          <RxCrossCircled className="h-[18px] w-[18px] cursor-pointer hover:text-blue-500" />
                        </div>
                      </div>

                      {suggestions?.length > 0 && searchPhone && (
                        <ul
                          ref={divRef}
                          className="absolute z-[999] mt-1 max-h-60 w-full overflow-auto rounded-lg border border-gray-300 bg-white shadow-md"
                        >
                          {suggestions?.map((user, index) => (
                            <li
                              key={index}
                              className="cursor-pointer px-4 py-2 hover:bg-gray-200"
                              onClick={() =>
                                handleSuggestionClick(user, setFieldValue)
                              }
                            >
                              {user?.phone_no}
                            </li>
                          ))}
                        </ul>
                      )}
                      <ErrorMessage
                        name="phone_no"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="cust relative mb-3">
                      <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("First Name")}
                      </label>

                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="first_name"
                        placeholder={t("First Name")}
                        value={values?.first_name}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          // handleInputChange(e, setFieldValue);
                          // setSearchName(e.target.value);
                          setFieldValue("first_name", e.target.value);
                        }}
                        autoComplete="off"
                      />

                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Last Name")}{" "}
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="last_name"
                        placeholder={t("Last Name")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                        // autoComplete="off"
                      />

                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {" "}
                        {t("Email")}{" "}
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="email"
                        placeholder={t("Email")}
                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="relative mb-3">
                      <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {" "}
                        {t("Password")}{" "}
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder={t("Password")}
                        // autoComplete="off"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[-20px] right-4 top-3 mt-1 flex"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <h1
                  style={{
                    fontWeight: "500",
                    fontSize: "20px",
                    textAlign: "start",
                    marginBottom: "2rem",
                  }}
                >
                  Addresses Details
                </h1>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <div className="flex flex-row items-center gap-4">
                      {userData?.address?.length > 0 && isEditing === null ? (
                        <div className="flex flex-row flex-wrap items-center gap-4">
                          {userData?.address?.map((element, idx) => {
                            const isSelected = values?.address?.includes(
                              element?.location
                            );
                            // const isChecked = selectedAddress[idx]?.is_selected;                               
                            const isChek = values?.address[idx]?.is_selected;
                            // Automatically select the address if there's only one
                            const isChecked = userData?.address?.length === 1 ? true : values?.address[idx]?.is_selected;

                            console.log("isCheckedsassasassssssssssssssssssssssssssssssss", isChecked);

                            return (
                              <div className="flex" key={idx}>
                                <div className="flex h-[130px] w-56 flex-col overflow-hidden rounded-lg bg-white shadow-md">
                                  <Card className="flex h-full flex-col p-0">
                                    <p>{element?.location?.slice(0, 50)}</p>
                                    {addressOne ? (
                                      <Checkbox
                                        onChange={(e) =>
                                          handleCheckBox(
                                            true,
                                            element,
                                            setFieldValue,
                                            values,
                                            idx
                                          )
                                        }
                                        value={true}
                                        checked={true}
                                      />
                                    ) : (
                                      <Checkbox
                                        onChange={(e) =>
                                          handleCheckBox(
                                            isChek,
                                            element,
                                            setFieldValue,
                                            values,
                                            idx
                                          )
                                        }
                                        checked={isChek}
                                      />
                                    )}
                                  </Card>
                                </div>
                              </div>
                            );
                          })}
                          <div>
                            <div
                              className="btn-gradient ml-2 mt-5 flex w-36  cursor-pointer flex-row items-center justify-center gap-2 rounded-lg p-5 text-[white]"
                              onClick={() => {
                                setIsEditing(values?.address?.length);
                                const currentAddresses = [
                                  ...values.address,
                                  {
                                    is_selected: false,
                                    location: "",
                                    building: "",
                                    apartment: "",
                                    geo: { coordinates: [] },
                                    floor: "",
                                    street: "",
                                    city: "",
                                    province: "",
                                    country: "",
                                    additional_directions: "",
                                  },
                                ];
                                setFieldValue(`address`, currentAddresses);
                              }}
                            >
                              <span>Add Address</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        isEditing !== null && (
                          <Row gutter={[16, 16]}>
                            <Col xs={24} md={12} lg={8} className="">
                              <label
                                for="floating_outlined"
                                className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                              >
                                {t("Location")}
                              </label>
                              <TextareaField
                                className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                name={`address.${isEditing}.location`}
                                placeholder={t("Location")}
                                value={values?.address[isEditing]?.location}
                                handleChange={(e) => {
                                  const addressInput = e.target.value;
                                  setFieldValue(
                                    `address.${isEditing}.location`,
                                    addressInput
                                  );
                                  searchAddress(
                                    addressInput,
                                    `address.${isEditing}.location`
                                  );
                                }}
                              />
                              {locationError && (
                                <div className="text-[14px] text-red-500">
                                  {locationError}
                                </div>
                              )}
                              {
                                <AddressAutocomplete
                                  suggestions={
                                    autocompleteSuggestions?.[
                                      `address.${isEditing}.location`
                                    ] ?? []
                                  }
                                  onSelectAddress={(address) =>
                                    onSelectAddress(address, setFieldValue)
                                  }
                                />
                              }
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="z-888 absolute start-1 top-2 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("Building")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.building`}
                                  placeholder={t("Building")}
                                />
                                <ErrorMessage
                                  name="address.building"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("Apartment")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.apartment`}
                                  placeholder={t("Apartment")}
                                />
                                <ErrorMessage
                                  name="address.apartment"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("Floor")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.floor`}
                                  placeholder={t("Floor")}
                                />
                                <ErrorMessage
                                  name="address.floor"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("Street")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.street`}
                                  placeholder={t("Street")}
                                />
                                <ErrorMessage
                                  name="address.street"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("City")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.city`}
                                  placeholder={t("City")}
                                  maxLength={20}
                                />
                                <ErrorMessage
                                  name="address.city"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("Province")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.province`}
                                  placeholder={t("Province")}
                                  maxLength={20}
                                  onKeyPress={(event) => {
                                    const charCode = event.charCode;
                                    if (
                                      !(charCode >= 65 && charCode <= 90) && // A-Z
                                      !(charCode >= 97 && charCode <= 122) && // a-z
                                      charCode !== 32 // space
                                    ) {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                                <ErrorMessage
                                  name="address.province"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("Country")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.country`}
                                  placeholder={t("Country")}
                                />
                                <ErrorMessage
                                  name="address.country"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="mb-3">
                                <label
                                  for="floating_outlined"
                                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                >
                                  {t("Additional Directions")}
                                </label>
                                <Field
                                  className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  type="text"
                                  name={`address.${isEditing}.additional_directions`}
                                  placeholder={t("Additional Directions")}
                                />
                                <ErrorMessage
                                  name="address.additional_directions"
                                  component="div"
                                  className="text-red-500"
                                />
                              </div>
                            </Col>
                            <Col span={24}>
                              <div className="flex w-full flex-row items-center justify-between">
                                <div className="mr-3 flex gap-[0.3rem]">
                                  <div className="checkbox-wrapper-40">
                                    <div className="flex gap-1">
                                      <svg
                                        width="21"
                                        height="19"
                                        viewBox="0 0 21 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M12.4386 1.2774C11.352 0.344382 9.71459 0.344382 8.62795 1.2774L1.2945 7.57428C0.899892 7.91309 0.86435 8.4968 1.21511 8.878C1.56587 9.2591 2.17011 9.29345 2.56471 8.95464L2.88557 8.67918V13.8659C2.88553 14.6845 2.88549 15.3898 2.9641 15.9547C3.04835 16.56 3.23834 17.1403 3.72556 17.6109C4.21278 18.0816 4.81346 18.2651 5.44011 18.3465C6.02484 18.4224 6.75501 18.4223 7.60246 18.4223H13.4641C14.3115 18.4223 15.0417 18.4224 15.6265 18.3465C16.2531 18.2651 16.8538 18.0816 17.341 17.6109C17.8282 17.1403 18.0182 16.56 18.1025 15.9547C18.1811 15.3898 18.1811 14.6845 18.181 13.866V8.67918L18.5018 8.95464C18.8964 9.29345 19.5007 9.2591 19.8514 8.878C20.2022 8.4968 20.1667 7.91309 19.7721 7.57428L12.4386 1.2774ZM10.5333 12.8817C10.0053 12.8817 9.57731 13.2951 9.57731 13.8051V15.652C9.57731 16.162 9.14933 16.5754 8.62135 16.5754C8.09339 16.5754 7.66539 16.162 7.66539 15.652V13.8051C7.66539 12.2751 8.94934 11.0348 10.5333 11.0348C12.1172 11.0348 13.4012 12.2751 13.4012 13.8051V15.652C13.4012 16.162 12.9732 16.5754 12.4452 16.5754C11.9172 16.5754 11.4892 16.162 11.4892 15.652V13.8051C11.4892 13.2951 11.0613 12.8817 10.5333 12.8817Z"
                                          fill={
                                            selectedCustmerType === "home"
                                              ? "#2F89DE"
                                              : "#9496AE"
                                          }
                                        />
                                      </svg>
                                      <input
                                        type="checkbox"
                                        className="cursor-pointer"
                                        style={{
                                          border:
                                            selectedCustmerType === "home"
                                              ? "1px solid #46BCED"
                                              : "1px solid #ccc",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        checked={selectedCustmerType === "home"}
                                        onChange={() =>
                                          handleCheckboxChange("home")
                                        }
                                      />
                                      <span
                                        className={`checkbox text-[12px] ${
                                          selectedCustmerType === "home"
                                            ? "text-[#3860A4]"
                                            : "#8B8B8B"
                                        }`}
                                      >
                                        Home
                                      </span>
                                    </div>
                                  </div>

                                  <div class="checkbox-wrapper-40">
                                    <div className="flex gap-1">
                                      <svg
                                        width="22"
                                        height="19"
                                        viewBox="0 0 22 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M12.0436 0.577637H9.9129C5.89522 0.577637 3.88637 0.577637 2.63823 1.82577C1.54894 2.91507 1.4103 4.58377 1.39266 7.66161V9.38439C0.987464 9.6176 0.667751 9.97918 0.486897 10.4158C0.324707 10.8074 0.324707 11.3037 0.324707 12.2965C0.324707 13.2893 0.324707 13.7857 0.486897 14.1773C0.703153 14.6993 1.11795 15.1142 1.64003 15.3305C1.90891 15.4418 2.22723 15.4767 2.72175 15.4876V17.6233C2.72175 18.0646 3.07949 18.4223 3.52077 18.4223C3.96205 18.4223 4.31979 18.0646 4.31979 17.6233V15.4926H17.6367V17.6233C17.6367 18.0646 17.9945 18.4223 18.4357 18.4223C18.877 18.4223 19.2348 18.0646 19.2348 17.6233V15.4876C19.7293 15.4767 20.0476 15.4418 20.3165 15.3305C20.8385 15.1142 21.2534 14.6993 21.4697 14.1773C21.6318 13.7857 21.6318 13.2893 21.6318 12.2965C21.6318 11.3037 21.6318 10.8074 21.4697 10.4158C21.2888 9.97918 20.969 9.6176 20.5639 9.3845V7.66161C20.5463 4.58377 20.4076 2.91507 19.3184 1.82577C18.0702 0.577637 16.0614 0.577637 12.0436 0.577637ZM18.7021 9.10058V7.44704C18.7022 6.48988 18.7022 5.69164 18.617 5.05801C18.527 4.38919 18.3292 3.78534 17.844 3.30011C17.3588 2.81487 16.7549 2.61707 16.0861 2.52714C15.4524 2.44195 14.6543 2.44198 13.697 2.44201H8.2595C7.3023 2.44198 6.50412 2.44195 5.87046 2.52714C5.20164 2.61707 4.59779 2.81487 4.11256 3.30011C3.62733 3.78534 3.42951 4.38919 3.3396 5.05801C3.2544 5.69166 3.25443 6.48984 3.25446 7.44704V9.10058C3.33909 9.10047 3.42775 9.10047 3.52077 9.10047H18.4357C18.5287 9.10047 18.6175 9.10047 18.7021 9.10058Z"
                                          fill={
                                            selectedCustmerType === "hotel"
                                              ? "#2F89DE"
                                              : "#9496AE"
                                          }
                                        />
                                      </svg>
                                      <input
                                        type="checkbox"
                                        className="ml-1 cursor-pointer"
                                        style={{
                                          border:
                                            selectedCustmerType === "hotel"
                                              ? "1px solid #46BCED"
                                              : "1px solid #ccc",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        checked={
                                          selectedCustmerType === "hotel"
                                        }
                                        onChange={() =>
                                          handleCheckboxChange("hotel")
                                        }
                                      />
                                      <span
                                        className={`checkbox text-[12px] ${
                                          selectedCustmerType === "hotel"
                                            ? "text-[#3860A4]"
                                            : "#8B8B8B"
                                        }`}
                                      >
                                        Hotel
                                      </span>
                                    </div>
                                  </div>

                                  <div class="checkbox-wrapper-40 mr-1">
                                    <div className="flex gap-1">
                                      <svg
                                        width="13"
                                        height="19"
                                        viewBox="0 0 13 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M1.52851 4.31511C1.32331 4.38409 1.14634 4.51833 1.02461 4.69735C0.90288 4.87636 0.843092 5.09029 0.854376 5.30648V18.4223H4.81986V12.4741H8.78535V18.4223H12.7508V0.577637L1.52851 4.31511Z"
                                          fill={
                                            selectedCustmerType === "work"
                                              ? "#2F89DE"
                                              : "#9496AE"
                                          }
                                        />
                                      </svg>
                                      <input
                                        type="checkbox"
                                        className="ml-1 cursor-pointer"
                                        style={{
                                          border:
                                            selectedCustmerType === "work"
                                              ? "1px solid #46BCED"
                                              : "1px solid #ccc",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        checked={selectedCustmerType === "work"}
                                        onChange={() =>
                                          handleCheckboxChange("work")
                                        }
                                      />
                                      <span
                                        className={`checkbox text-[12px] ${
                                          selectedCustmerType === "work"
                                            ? "text-[#3860A4]"
                                            : "#8B8B8B"
                                        }`}
                                      >
                                        Work
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {console.log(values?.address, "valuesadfasdf")}
                                <div className="flex flex-row items-center gap-5">
                                  <div
                                    onClick={() => {
                                      if (userData?.address?.length > 0) {
                                        setIsEditing(null);
                                      } else {
                                        return;
                                      }
                                    }}
                                    className="bg-transparent cursor-pointer rounded-xl border-[1px] px-5 py-[12px]  text-base font-medium hover:border-blue-500 hover:text-blue-500"
                                  >
                                    Cancel
                                  </div>
                                  <div
                                    onClick={() => {
                                      if (
                                        values.address[isEditing]?.location ===
                                        ""
                                      ) {
                                        setLocationErrorr("Required");
                                        return;
                                      } else {
                                        handleSaveAddress(
                                          setFieldValue,
                                          values,
                                          values?.address[isEditing]?.location
                                        );
                                        setLocationErrorr("");
                                      }
                                    }}
                                    className="linear w-full max-w-[9rem]  cursor-pointer rounded-xl bg-brand-500 px-5 py-[12px] text-center text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                                  >
                                    Save Address
                                  </div>
                                </div>
                              </div>
                              {console.log("dadasdasdas", errors)}
                            </Col>
                          </Row>
                        )
                      )}
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-center">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting
                      ? currentData
                        ? t("Adding...")
                        : t("Creating") + "..."
                      : currentData
                      ? t("Add User")
                      : t("Create User")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateOrderUser;
